import classNames from 'classnames';

import { POSITION } from 'enums/common';

const styles = {
  container: classNames(
    'bg-white',
    'bottom-4',
    'py-4',
    'px-6',
    'rounded-xl',
    'right-4',
    'left-4',
    'shadow-xl',
    'flex',
    'flex-wrap',
    'gap-2',
    'flex-col',
    'gap-2',
    'items-center',
    'lg:items-start',
    'justify-between',
    'text-mainBlue',
    'text-xs md:text-sm lg:text-lg',
  ),
  title: classNames(
    'font-extrabold',
  ),
  measures: classNames(
    'flex',
    'flex-none',
    'justify-between',
    'gap-4',
    'w-full',
  ),
  measure: (position: POSITION) => classNames(
    'lowercase',
    'flex',
    'flex-wrap',
    'gap-1',
    'items-center',
    'text-center',
    'justify-center',
    {
      '[&>svg>path:nth-child(1)]:stroke-error': position === POSITION.TOP,
      '[&>svg>path:nth-child(2)]:stroke-error': position === POSITION.BOTTOM,
      '[&>svg>path:nth-child(3)]:stroke-error': position === POSITION.RIGHT,
      '[&>svg>path:nth-child(4)]:stroke-error': position === POSITION.LEFT,
    },
  ),
};

export default styles;
